import { combineReducers } from 'redux';
import { handleActions, handleAction } from 'redux-actions';
import fromPairs from 'lodash/fromPairs';
import { partsFormActions } from 'shared/actions/partsForm';
import transportTypes from 'shared/constants/json/transportTypes.json';
import currency from 'shared/constants/json/currency.json';
import { getAllLocations } from 'shared/helpers/locale';
// import CITIES from 'shared/constants/json/cities.json';
import partsStatuses from 'shared/constants/json/partsStatuses.json';
import sellingTypes from 'shared/constants/json/partsSellingTypes.json';

const selectedPairs = Object.entries(partsFormActions.partsForm.selected.set);
const vocabularyPairs = Object.entries(partsFormActions.partsForm.vocabulary);
const selectedActions = partsFormActions.partsForm.selected;

const immutablySetField = (state, field, value) => ({
  ...state,
  [field]: value,
});

const initialState = {
  selected: {
    ...fromPairs(selectedPairs.map(([key]) => [key, null])),
    photos: [],
    phones: [],
    currency: currency.find(currencyItem => currencyItem.slug === 'usd'),
    advertFields: {},
  },
  vocabulary: {
    ...fromPairs(vocabularyPairs.map(([key]) => [key, null])),
    //
    transports: transportTypes.filter(type => type.parents.length === 0),
    currency,
    locations: getAllLocations(true),
    statuses: partsStatuses,
    sellingTypes,
  },
  isEdit: false,
};

const selected = handleActions(
  {
    // Clear
    [partsFormActions.partsForm.clear]: () => initialState.selected,
    // Default setters for all
    ...fromPairs(
      selectedPairs.map(([key, value]) => [
        // toString() of the action creator gives us an action type string
        value,
        (state, action) => immutablySetField(state, key, action.payload),
      ]),
    ),
    // Photos
    [selectedActions.add.photos]: (state, action) =>
      immutablySetField(state, 'photos', [...state.photos, action.payload]),
    [selectedActions.remove.photos]: (state, action) =>
      immutablySetField(state, 'photos', state.photos.filter(p => p.id !== action.payload)),
    // Phones
    [selectedActions.add.phones]: (state, action) =>
      immutablySetField(
        state,
        'phones',
        state.phones.includes(action.payload) ? state.phones : [...state.phones, action.payload],
      ),
    [selectedActions.remove.phones]: (state, action) =>
      immutablySetField(state, 'phones', state.phones.filter(phone => phone !== action.payload)),
    // advertFields
    [selectedActions.toggle.advertFields]: (state, action) =>
      immutablySetField(state, 'advertFields', {
        ...state.advertFields,
        [action.payload]: !state.advertFields[action.payload],
      }),
  },
  initialState.selected,
);

const vocabulary = handleActions(
  {
    // Clear
    [partsFormActions.partsForm.clear]: () => initialState.vocabulary,
    // Default setters for vocabulary fields
    ...fromPairs(
      vocabularyPairs.map(([key, value]) => [
        value,
        (state, action) => immutablySetField(state, key, action.payload),
      ]),
    ),
  },
  initialState.vocabulary,
);

const isEdit = handleAction(
  partsFormActions.partsForm.isEdit,
  (state, action) => action.payload,
  initialState.isEdit,
);

export default combineReducers({
  selected,
  vocabulary,
  isEdit,
});



// WEBPACK FOOTER //
// ./src/shared/reducers/partsForm.js